<template>
    <div class="content">
        <Row type="flex" align="middle" class="mb16">
            <Col span="24">
              <Breadcrumb>
                <Breadcrumb-item to="/">首页</Breadcrumb-item>
                <Breadcrumb-item to="/my/customizedCCIC/insurance">我的投保单</Breadcrumb-item>
                <Breadcrumb-item>投保单详情</Breadcrumb-item>
              </Breadcrumb>
            </Col>
        </Row>
        <!-- 投保单基本信息 -->
        <PolicyBasicInfo class="mb16" :info="info" type="insurance" title="投保单基本信息"/>
        <!-- 投保公司 -->
        <insuranceCompany class="mb16" :info="info" type="insurance" />
        <!-- 被保人信息 -->
        <InsuredPersonInfo class="mb16" :info="info" type="insurance" />
        <!-- 保障计划及人员 -->
        <supportPlans
          class="mb16"
          :info="info"
          type="insurance"
        />
  </div>
</template>
<script>
import PolicyBasicInfo from "../common/PolicyBasicInfo";
import insuranceCompany from "../common/insuranceCompany";
import supportPlans from "../common/supportPlans";
import InsuredPersonInfo from "../common/InsuredPersonInfo";
export default {
  components: {
    PolicyBasicInfo,
    insuranceCompany,
    supportPlans,
    InsuredPersonInfo
  },
  data() {
    return {
      info: {},
      applicationNo: this.$route.params.id,
      loading: false
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    resultMap(status) {
      const resultMap = {
        中国平安: 10029,
        中国人保: 10147,
        泰康保险: 10028,
        阳光保险: 10027,
        中国人寿: 10031,
        中国太平洋: 10066
      };
      return resultMap[status];
    },
    onCheck(item) {
      this.confirm(
        "确认选择此方案吗？",
        () => {
          if (
            this.info.extraInfo.insureCompanyQuoteList.filter(
              item => item.quoteState == "QUOTING"
            ).length > 0
          ) {
            this.$Message.error("请等待所有保险公司报价");
            return false;
          }
          const params = {
            ...this.info,
            premium: (
              Number(item.premiumRate) *
              100 *
              this.info.extraInfo.bzbd
            ).toFixed(2),
            insuranceCompanyName: item.insuranceCompanyName,
            companyId: this.resultMap(item.insuranceCompanyName)
          };
          this.$axios
            .post("/broker/insurance/application/apply.json", params)
            .then(res => {
              this.$Message.success("成功!");
              this.$axios
                .post("/broker/insurance/application/confirm.all", {
                  applicationId: res
                })
                .then(response => {
                  // 跳转支付
                  window.location.href=`/common.html#/payCCIC?orderNo=${response.data}&productCode=${this.info.productCode}`
                });
            });
        },
        {
          okText: "确定",
          cancelText: "取消"
        }
      );
    },
    /*企业雇主责任险获取订单信息*/
    async getInfo() {
      await this.$axios
        .post("/broker/insurance/application/detailByApplicationNo", {
          applicationNo: this.applicationNo
        })
        .then(res => {
          this.info = res;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.flex {
  display: flex;
}
.flex-direction-column {
  flex-direction: column;
}
.flex-1 {
  flex: 1;
}
.item-center {
  align-items: center;
}
.quotation {
  &-title {
    font-size: 14px;
    padding: 10px;
    color: #000;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    background: #f3f3f3;
    height: 65px;
    display: flex;
    align-items: center;
  }
  &-p {
    font-size: 14px;
    padding: 10px;
    border-bottom: 1px solid #f5f5f5;
    color: #666;
    height: 65px;
    display: flex;
    align-items: center;
  }

  &-h {
    height: 100px;
    margin: 10px 0;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/insurance/detail.vue